// extracted by mini-css-extract-plugin
export default {"container":"Control_container__UM2Gq","control":"Control_control__w0FHU"};